import { render, staticRenderFns } from "./Women.vue?vue&type=template&id=3d1d3de9&"
import script from "./Women.vue?vue&type=script&lang=js&"
export * from "./Women.vue?vue&type=script&lang=js&"
import style0 from "./Women.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports